import { eventsEndpoint } from '@/ui/core/config'
import { GuestbookClient } from '../GuestbookClient'

export async function deleteEvent(
  this: GuestbookClient,
  eventId: string,
): Promise<void> {
  const jwtToken = (await this.auth.getJWT()) ?? ''
  const params = new URLSearchParams({ id: eventId }).toString()
  await fetch(`${eventsEndpoint}?${params}`, {
    method: 'DELETE',
    headers: {
      Authorization: jwtToken,
    },
  })
}
